import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


function September() {


  return (
    <section id="about" className="block about-block">
      <Container fluid style={{ marginTop: "40px" }}>
        <div className="title-holder" style={{ color: "#0c71c3" }}>
          <h2>Events Of The Month</h2>
          <div className="subtitle" style={{ color: "#0c71c3" }}>EAI Events For September</div>
        </div>
        <Row>
        <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/abao2.mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2025</p>
            <p>SCHOOL NAME: COMMUNITY SECONDARY SCHOOL ABAOMEGE ONICHA</p>
            <p>LOCAL GOVERNMENT: ONICHA LGA
            </p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Community secondary school Abaomege Onicha, where the organization donated study materials to the students. The materials ranged from pencils and textbooks to notebooks. This was done in an effort to support underprivileged students in public schools across Ebonyi State. Our donations align with findings from our survey, which revealed that many students face challenges due to a lack of study materials.</p>
          </Col>




          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/abao.mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2025</p>
            <p>SCHOOL NAME: CENTRAL PRIMARY SCHOOL ABAOMEGE ONICHA</p>
            <p>LOCAL GOVERNMENT: ONICHA LGA
            </p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Central primary school Abaomege Onicha, where the organization donated study materials to the students. The materials ranged from pencils and textbooks to notebooks. This was done in an effort to support underprivileged students in public schools across Ebonyi State. Our donations align with findings from our survey, which revealed that many students face challenges due to a lack of study materials.</p>
          </Col>

          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/ikwo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2025</p>
            <p>SCHOOL NAME: CENTRAL SCHOOL IGBOJI IKWO</p>
            <p>LOCAL GOVERNMENT: IKWO</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Central School Igboji Ikwo, where the organization donated study materials to the students. The materials ranged from pencils and textbooks to notebooks. This was done in an effort to support underprivileged students in public schools across Ebonyi State. Our donations align with findings from our survey, which revealed that many students face challenges due to a lack of study materials.</p>
          </Col>

          {/* OGBAGA NKALIKI */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/oga.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2023</p>
            <p>SCHOOL NAME: OGBAGA NKALIKI COMMUNITY PRIMARY SCHOOL</p>
            <p>LOCAL GOVERNMENT: EBONYI</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Ogbaga Nkaliki Community Primary School, where the organization donated study materials including pencils, textbooks, and notebooks. The initiative aims to support less privileged students in public schools across Ebonyi State. The donation is a response to our survey indicating that students are struggling due to limited access to learning materials.</p>
          </Col>

          {/* AMANDA COMMUNITY PRIMARY */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/oha.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2024</p>
            <p>SCHOOL NAME: AMANDA COMMUNITY PRIMARY SCHOOL</p>
            <p>LOCAL GOVERNMENT: OHAOZARA</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Amanda Community Primary School and donated study materials including pencils, textbooks, and notebooks. This effort is part of our mission to support underprivileged students in public schools throughout Ebonyi State, based on survey findings that highlight the lack of adequate study resources.</p>
          </Col>

          {/* ABINA AMAGU PRIMARY */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/oha.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2024</p>
            <p>SCHOOL NAME: COMMUNITY PRIMARY SCHOOL ABINA AMAGU</p>
            <p>LOCAL GOVERNMENT: IKWO</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Community Primary School Abina Amagu and donated a variety of study materials. These donations are intended to support less privileged students and address challenges identified through our educational survey in Ebonyi State.</p>
          </Col>

          {/* UGWULANGWU SECONDARY JSS */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/ug.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2024</p>
            <p>SCHOOL NAME: UGWULANGWU SECONDARY JSS</p>
            <p>LOCAL GOVERNMENT: OHAOZARA</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Ugwulangwu Secondary JSS to provide essential study materials. The donation included pencils, textbooks, and notebooks, made to improve academic outcomes for students lacking basic learning resources.</p>
          </Col>

          {/* COMMUNITY JUNIOR SECONDARY ABINA */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/ab.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2024</p>
            <p>SCHOOL NAME: COMMUNITY JUNIOR SECONDARY ABINA AMAGU</p>
            <p>LOCAL GOVERNMENT: IKWO</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Community Junior Secondary Abina Amagu to donate learning materials. These efforts are part of our broader initiative to empower students in public schools who lack access to quality educational tools.</p>
          </Col>

          {/* IKWO HIGH SCHOOL */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/ab.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2024</p>
            <p>SCHOOL NAME: IKWO HIGH SCHOOL AGBIA</p>
            <p>LOCAL GOVERNMENT: IKWO</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Ikwo High School Agbia and donated study tools such as textbooks, notebooks, and pencils to students in need. This outreach aims to reduce barriers to academic success in public schools across Ebonyi State.</p>
          </Col>

          {/* UMUOGHARA SECONDARY */}
          <Col sm={6}>
            <video
              controls
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                objectFit: "cover",
              }}
            >
              <source src="https://emekaanyimude.s3.eu-north-1.amazonaws.com/um.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col sm={6}>
            <p>MONTH: SEPTEMBER</p>
            <p>YEAR: 2024</p>
            <p>SCHOOL NAME: COMMUNITY JUNIOR SECONDARY SCHOOL UMUOGHARA</p>
            <p>LOCAL GOVERNMENT: EZZA NORTH</p>
            <p>STATE: EBONYI</p>
            <p>DONATION TYPE: TEXTBOOKS</p>
            <p>The Emeka Anyimude Initiative visited Community Junior Secondary School Umuoghara, where students received various study resources including textbooks, notebooks, and pencils. These donations help bridge the learning gap for underprivileged students throughout Ebonyi State.</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default September;
